import { SsrService } from '@/common/services/ssr/ssr.service';
import { environment as env } from '@/env/environment';
import { AfterViewInit, Component } from '@angular/core';

declare const hbspt: any;

@Component({
    selector: 'fe-hbsptform',
    templateUrl: './hbsptform.component.html',
    styleUrls: ['./hbsptform.component.scss'],
})
export class HbsptformComponent implements AfterViewInit {
    constructor(private readonly ssr: SsrService) {}
    ngAfterViewInit(): void {
        if (this.ssr.isPlatformServer()) {
            return;
        }
        hbspt.forms.create({
            region: env.hbsptform.region,
            portalId: env.hbsptform.portalId,
            formId: env.hbsptform.formId,
            target: '#hubspotForm',
        });
    }
}
